// BOORO: task status as people read it.
import { useLingui } from "@lingui/react/macro";
import type { TaskDisplayStatus } from "@rakazo/contracts";
import { useMemo } from "react";

export function useTaskDisplayStatusLabels(): Record<TaskDisplayStatus, string> {
  const { t } = useLingui();
  return useMemo(
    () => ({
      new: t`New`,
      working: t`In progress`,
      waiting: t`Waiting for you`,
      blocked: t`Blocked`,
      done: t`Done`,
      dropped: t`Dropped`,
    }),
    [t],
  );
}
